/** 検索エンジンに載せたい本番ホスト。Vercel の *.vercel.app は含めない */
export const PRODUCTION_HOST = 'ai-camera.lab.mdg-meidai.com';
export const PRODUCTION_ORIGIN = `https://${PRODUCTION_HOST}`;

export function getHostname(hostname) {
  if (typeof hostname === 'string' && hostname) {
    return hostname;
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return '';
}

/** 本番ドメイン以外（vercel.app / localhost 等）は検索に出さない */
export function isSearchIndexableHost(hostname) {
  return getHostname(hostname) === PRODUCTION_HOST;
}

export function getRobotsMetaContent(hostname) {
  return isSearchIndexableHost(hostname) ? 'index,follow' : 'noindex,nofollow';
}
